// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "textarea[data-v-55138de0]{resize:none}", "",{"version":3,"sources":["/var/www/html/two_digital/app/javascript/components/Textarea.vue"],"names":[],"mappings":"AAwFA,0BACE,WAAA","file":"Textarea.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\ntextarea {\n  resize: none;\n}\n"]}]);
// Exports
module.exports = exports;
